// @flow
import React, { useEffect, useContext } from 'react';
import useFlux from '@homie/flux/useFlux';
import HomieContext from 'HomieContext';
import AuthorizationStore from 'stores/AuthorizationStore';
import { fetchPermissions } from 'actions/AuthorizationActions';
import PermissionsContext from './PermissionsContext';

const PermissionsProvider = ({ children }: any) => {
  const { currentUser } = useContext(HomieContext);
  const { permissions } = useFlux(
    () => ({
      permissions: AuthorizationStore.getPermissions()
    }),
    [AuthorizationStore]
  );

  useEffect(() => {
    fetchPermissions(currentUser.id);
  }, [currentUser.authenticated]);

  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export default PermissionsProvider;
